import React, { useEffect, useState } from "react";
import moment from "moment";
import "./EditSales.scss";
import CatchDisposition from "../../components/CatchDisposition";
import { Box, Grid } from "@mui/material";
import Dealer from "../../components/Dealer";
import Port from "../../components/Port";
import DefaultButton from "../../components/DefaultButton";
import DateSold from "../../components/DateSold";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { SalesCombinedEncRow } from "../../constants/Sales";
import {
  dateTimeSavedToDisplay,
  getCurrentOpenTrip,
} from "../../constants/vtrTrip";
import Spinner from "../../components/common/Spinner";
import { Navigate, useLocation } from "react-router-dom";
import {
  validateSales,
  validateSalesExtra,
} from "../../constants/salesValidations";
import TitleBar from "../../components/TitleBar";
import { success, info, danger } from "../../constants/colors";
import AdditionalForm from "../../forms/SalesForm3/SalesForm3";
import DeleteSalesDialog from "./DeleteSalesDialog";

function EditSales(props) {
  const { actions } = props;
  const { vtrTrip, auth, helpText } = useSelector((state) => state);
  const location = useLocation();
  const [showForm, setShowForm] = useState(false);
  const [showModal, toggleModal] = useState(false);
  const [toggleOption, setToggleOption] = useState(false);
  const [showAdditionalForm, setShowAdditionalForm] = useState(false);
  const targetSpecies = ["CLHB", "CLQUB", "CLSOB", "CLSUB"];
  const [values, setValues] = useState({
    isLoaded: false,
    isExisting: false,
    trip_type: null,
    sold: null,
    display_date_sold: "",
    date_sold: "",
    species: "",
    dealer_permit_number: "",
    dealer_name: "",
    offloading_port: "",
    price_per_bushel: "",
    allocation_numbers: [],
    tag_numbers: [],
    currentStep: 1,
    maximumStep: 2,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    let tripId = location.state.trip_id;
    let allOpenTrips = vtrTrip.allOpenTrips;
    let currentOpenTrip = getCurrentOpenTrip(allOpenTrips, tripId);
    let newState = {};
    let tripType = currentOpenTrip.trip_type;
    let reportType = currentOpenTrip.report_type;
    newState.trip_type = tripType;
    newState.report_type = reportType;
    newState.trip_id = tripId;
    let salesId = location.state.sales_id;
    let sumCatch = [];
    let allCatch = [];
    let speciesDone = [];
    let catchSpecies = [];
    let salesSpecies = [];
    let allEfforts = currentOpenTrip.images;
    let allSales = currentOpenTrip.sales;
    let sumSales = [];
    let salesAvailable = 0;
    let originalAvailable = 0;
    let kept = 0;

    if (salesId !== undefined) {
      if (allSales[salesId]) {
        newState.sales_id = salesId;
        let currentSales = allSales[salesId];
        console.table(currentSales);
        newState.sold = Number(currentSales.sold);
        newState.original_sold = currentSales.sold;
        newState.date_sold = currentSales.date_sold;
        newState.display_date_sold = dateTimeSavedToDisplay(
          currentSales.date_sold
        );
        newState.species = currentSales.species;
        newState.dealer_name = currentSales.dealer_name;
        newState.dealer_permit_number = currentSales.dealer_permit_number;
        newState.uom = currentSales.uom;
        newState.offloading_port = currentSales.offloading_port;
        newState.price_per_bushel = currentSales.price_per_bushel;
        newState.allocation_numbers = currentSales.allocation_numbers;
        newState.tag_numbers = currentSales.tag_numbers;
        newState.isExisting = true;

        setShowAdditionalForm(targetSpecies.includes(currentSales.species));
        setToggleOption(
          targetSpecies.includes(currentSales.species) && reportType === "3"
            ? true
            : false
        );

        allEfforts.forEach((effort) => {
          if (effort.hasOwnProperty("catch")) {
            allCatch = allCatch.concat(effort.catch);
          }
        });

        allCatch.forEach((item) => {
          if (item.species && Number(item.kept) > 0) {
            if (!catchSpecies.includes(item.species)) {
              sumCatch.push({
                species: item.species,
                kept: Number(item.kept),
                uom: item.uom,
              });
              catchSpecies.push(item.species);
            } else {
              sumCatch.forEach((sum) => {
                if (sum.species === item.species) {
                  sum.kept = Number(item.kept) + Number(sum.kept);
                  return;
                }
              });
            }
          }
        });

        allSales.forEach((sales) => {
          if (sales.species && Number(sales.sold) > 0) {
            if (!salesSpecies.includes(sales.species)) {
              sumSales.push({
                species: sales.species,
                sold: Number(sales.sold),
                uom: sales.uom,
              });
              salesSpecies.push(sales.species);
            } else {
              sumSales.forEach((item) => {
                if (item.species === sales.species) {
                  item.sold = Number(sales.sold) + Number(item.sold);
                  return;
                }
              });
            }
          }
        });

        speciesDone = salesSpecies.concat(
          catchSpecies.filter((item) => salesSpecies.indexOf(item) < 0)
        );
        let combinedSum = [];
        speciesDone.forEach((item) => {
          let enc = new SalesCombinedEncRow();
          let currentCatch;
          sumCatch.forEach((sum) => {
            if (sum.species === item) {
              currentCatch = sum;
              return;
            }
          });
          let currentSale;
          sumSales.forEach((sale) => {
            if (
              sale &&
              sale.hasOwnProperty("species") &&
              sale.species === item
            ) {
              currentSale = sale;
              return;
            }
          });
          if (currentCatch && currentSale) {
            enc.setSpecies(currentCatch.species);
            enc.setCatchUom(currentCatch.uom);
            enc.setTotalAvailable(currentCatch.kept);
            enc.setOriginalAvailable(currentCatch.kept - currentSale.sold);
            enc.setAvailable(currentCatch.kept - currentSale.sold);
            enc.setSold(currentSale.sold);
            enc.setSalesUom(currentSale.uom);
          } else if (currentCatch && !currentSale) {
            enc.setSpecies(currentCatch.species);
            enc.setCatchUom(currentCatch.uom);
            enc.setTotalAvailable(currentCatch.kept);
            enc.setOriginalAvailable(currentCatch.kept);
            enc.setAvailable(currentCatch.kept);
            enc.setSold(0);
            enc.setSalesUom(currentCatch.uom);
          } else {
            enc.setSpecies(currentSale.species);
            enc.setCatchUom(currentSale.uom);
            enc.setTotalAvailable(0);
            enc.setOriginalAvailable(0);
            enc.setAvailable(0 - currentSale.sold);
            enc.setSold(currentSale.sold);
            enc.setSalesUom(currentSale.uom);
          }
          combinedSum[combinedSum.length] = enc;
          if (currentSales.species === enc.species) {
            newState.currentSale_sold = currentSale.sold;
            newState.currentSales_sold = currentSales.sold;
            originalAvailable =
              Number(enc.total_available) -
              Number(currentSale.sold) +
              Number(currentSales.sold);
            salesAvailable =
              Number(enc.total_available) - Number(currentSale.sold);
            kept = Number(enc.total_available);
          }
        });

        newState.salesAvailable = salesAvailable;
        newState.original_available = originalAvailable;
        newState.total_kept = kept;
      }
    }
    newState.isLoaded = true;
    setValues({ ...values, ...newState });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _next = (event, value) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    let errors1 = [];
    let errors2 = [];

    errors1 = validateSales(values);
    if (showForm) {
      errors2 = validateSalesExtra(values);
    }
    let allErrors = errors1.concat(errors2);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      return;
    }
    setShowForm(!showForm);
    setToggleOption(!toggleOption);
    if (value === "Save") {
      actions.updateSales(
        values,
        auth.client_id,
        values.trip_id,
        values.sales_id
      );
    }
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    setShowForm(!showForm);
    setToggleOption(!toggleOption);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleCatchDispositionChange = (event, newValues) => {
    event.preventDefault();
    console.group("handleCatchDispositionChange");

    const originalSold = newValues.original_sold;
    const newSold = event.target.value;
    const originalAvailable = newValues.originalAvailable;
    const diffSold = Number(originalSold) - Number(newSold);
    const salesAvailable = Number(originalAvailable) - newSold;
    console.log("originalSold", originalSold);
    console.log("diffSold", diffSold);
    console.log("newValues", newValues);
    console.log(newSold);
    console.log(originalAvailable);
    let newState = {};
    newState.sold = newSold;
    newState.salesAvailable = salesAvailable;
    console.log(newState);
    console.groupEnd();
    if (newSold > originalAvailable) {
      console.error(
        "newSold " +
          newSold +
          " larger then originalAvailable " +
          originalAvailable
      );
      return;
    }
    if (newSold < 0) {
      console.error("newSold " + newSold + " smaller than zero");
      return;
    }

    setValues({ ...values, ...newState });
  };

  const _showConfirm = () => {
    toggleModal(true);
  };

  const _closeConfirm = (event) => {
    event.preventDefault();
    toggleModal(false);
    actions.deleteSales(event);
  };

  const dealerChangeHandler = (event, reason) => {
    event.preventDefault();
    if (reason) {
      setValues({
        ...values,
        dealer_permit_number: reason.DEALER_PERMIT_NUMBER,
        dealer_name: reason.DEALER_NAME,
      });
    }
  };

  const handleDealerPreferenceChange = function (event) {
    event.preventDefault();
    let dealerName = event.currentTarget.dataset.dealer_name;
    let dealerPermitNumber = event.currentTarget.dataset.dealer_permit_number;
    if (!dealerPermitNumber) {
      console.log("No new dealer permit number provided");
      return;
    }
    if (!dealerName) {
      console.log("No new dealer name provided");
      return;
    }

    setValues({
      ...values,
      dealer_name: dealerName,
      dealer_permit_number: dealerPermitNumber,
    });
  };

  const portChangeHandler = function (event, reason) {
    event.preventDefault();
    if (reason) {
      setValues({
        ...values,
        offloading_port: reason.ID,
        port_name: reason.NAME,
        port_state: reason.STATE,
        port_city: reason.CITY,
        my_name: reason.my_name,
      });
    } else {
      //If emptied then empty the state
      setValues({
        ...values,
        offloading_port: "",
        port_name: "",
        port_state: "",
        port_city: "",
      });
    }
  };

  const handlePortPreferenceChange = function (event) {
    event.preventDefault();
    const { port_id, port_name, port_state, port_city } =
      event.currentTarget.dataset;
    setValues({
      ...values,
      port_name,
      offloading_port: port_id,
      port_city,
      port_state,
    });
  };

  const DateSoldNowHandler = function (event) {
    event.preventDefault();
    let d = moment();
    const format = "DD-MMM-YY";
    let newState = {};
    newState.date_sold = d.format("YYMMDD");
    newState.display_date_sold = d.format(format);
    setValues({ ...values, ...newState });
  };

  const dateSoldHandler = function (date) {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY");
        let bDateTime = dt.format("YYMMDD");
        setValues({
          ...values,
          display_date_sold: newDateTime,
          date_sold: bDateTime,
        });
      } else {
        setValues({ ...values, display_date_sold: newDateTime, date_sold: "" });
      }
    } else {
      setValues({ ...values, display_date_sold: "", date_sold: "" });
    }
  };

  const handlePricePerBushel = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({ ...values, [name]: parseFloat(value).toFixed(2) });
  };

  const handleAllocationChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const newAllocationNumber = [...values.allocation_numbers];
    newAllocationNumber[0] = value;
    setValues({ ...values, [name]: [...newAllocationNumber] });
  };

  const handleDeleteTagRange = (idx) => {
    const reduceArr = [...values.tag_numbers];
    reduceArr.splice(idx, 1);
    setValues({ ...values, tag_numbers: reduceArr });
  };

  const handleTagNumberRangeChange = (value) => {
    let newTagNumbers = [...values.tag_numbers];
    newTagNumbers.push(value);
    setValues({ ...values, tag_numbers: [...newTagNumbers] });
  };

  if (values.isLoaded === false) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (vtrTrip.redirect && values.isLoaded) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
        state={{
          trip_id: values.trip_id,
          client_id: auth.client_id,
        }}
      />
    );
  }

  return (
    <div className="SalesWizardPage margAll10" data-testid="SalesWizardPage">
      <TitleBar
        title="Catch Disposition"
        delete_button={values.isExisting === true ? _showConfirm : false}
      />
      {showModal && (
        <DeleteSalesDialog
          client_id={auth.client_id}
          trip_id={location.state.trip_id}
          sales_id={location.state.sales_id}
          showDialog={showModal}
          hideDialog={toggleModal}
          deleteSales={_closeConfirm}
        />
      )}
      {!showForm && (
        <>
          <CatchDisposition
            trip_id={values.tripId}
            triptype={Number(values.trip_type)}
            helpText={helpText.helpText}
            species={values.species}
            sold={values.sold}
            total_kept={values.total_kept}
            salesAvailable={values.salesAvailable}
            originalAvailable={values.original_available}
            original_sold={values.original_sold}
            handleCatchDispositionChange={handleCatchDispositionChange}
            sales_uom={values.uom}
          />

          <Dealer
            dealer_permit_number={values.dealer_permit_number}
            dealer_name={values.dealer_name}
            helpText={helpText.helpText}
            changeHandler={dealerChangeHandler}
            handleDealerPreferenceChange={handleDealerPreferenceChange}
          />
          <Port
            helpText={helpText.helpText}
            changeHandler={portChangeHandler}
            handlePortPreferenceChange={handlePortPreferenceChange}
            port_id={values.offloading_port}
            port_state={values.port_state}
            port_name={values.port_name}
            port_city={values.port_city}
          />
          <DateSold
            DateSoldNowHandler={DateSoldNowHandler}
            display_date_sold={values.display_date_sold}
            dateSoldHandler={dateSoldHandler}
            helpText={helpText.helpText}
          />
        </>
      )}
      {showForm && showAdditionalForm && (
        <AdditionalForm
          currentStep={3}
          trip_type={values.trip_type}
          species={values.species}
          pricePerBushel={values.price_per_bushel}
          allocationNumbers={values.allocation_numbers}
          tagNumbers={values.tag_numbers}
          handleInputChange={handleInputChange}
          handlePricePerBushel={handlePricePerBushel}
          handleDeleteTag={handleDeleteTagRange}
          handleTagChange={handleTagNumberRangeChange}
          handleAllocationChange={handleAllocationChange}
        />
      )}

      <Box
        mt={5}
        width="100%"
        align="center"
        className="bottom-nav-container margBot20"
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton
              changeHandler={_cancel}
              buttonText={showForm ? "Back" : "Cancel"}
            />
          </Grid>
          <Grid item xs="auto" className="margRight20">
            <DefaultButton
              changeHandler={_next}
              buttonText={toggleOption ? "Next" : "Save"}
              bgColor={toggleOption ? info : success}
            />
          </Grid>
          {values.isExisting === true && (
            <Grid item xs="auto">
              <DefaultButton
                changeHandler={
                  values.isExisting === true ? _showConfirm : false
                }
                buttonText={"Delete"}
                bgColor={danger}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(EditSales);
